export const BACKEND_SERVER = {
    url: process.env.NODE_ENV === 'production' ? "https://api.beta.wos.wellis.com/" : "https://api.wos.wellis.local/",
    headers: {
        auth: 'x-app-authorization',
        lang: 'x-app-language'
    }
};

export const CONFIGURATOR = {
    VALID_HOSTS: ['PRODUCT', 'STOCK_FIFO', 'STOCK_ETA', 'SHOPORD']
}

export const VAT_MULTIPLIER = 1.27;
